import React from 'react'
import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const CatalogItemDetails = () => {
  return (
    <MicroFrontEnd
      name="CatalogItemDetails"
      src={apiConfig.microFrontEnds.CatalogItemDetails}
    />
  )
}

export default CatalogItemDetails
